import React, { useEffect, useState } from "react";
import { images } from "../../config/images";
import "../AboutUs/AboutUs.css";
import CommonBreadcrumbs from "../../components/Breadcrumb/Breadcrumb";
import { Grid } from "@mui/material";
import AboutUsculture from "../../components/AboutUsCulture/AboutUsCulture";
import { FaCircleCheck } from "react-icons/fa6";
import { aboutUsData } from "../../config/services";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";

const sanitizeHTML = (html) => {
  const doc = new DOMParser().parseFromString(html, "text/html");
  const elements = doc.body.getElementsByTagName("*");

  // List of allowed tags

  const allowedTags = ["P", "A", "STRONG", "BR", "BR"];
  // Loop through each element and remove non-allowed tags
  Array.from(elements).forEach((el) => {
    if (!allowedTags.includes(el.nodeName)) {
      el.remove();
    }

    // Remove potentially dangerous attributes like "on*" (JavaScript event listeners)
    Array.from(el.attributes).forEach((attr) => {
      if (attr.name.startsWith("on")) {
        el.removeAttribute(attr.name);
      }
    });
  });

  return doc.body.innerHTML;
};


const Aboutus = ({ settingAPIData, headerAPIData }) => {
  const [aboutUsAPIData, setAboutUsAPIData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  const breadcrumbsData = [
    { label: "Home", url: "/" },
    {
      label: "About Us",
      url: "/aboutus",
    },
  ];

  useEffect(() => {
    handleAboutUsData();
  }, []);

  const handleAboutUsData = async () => {
    setIsLoading(true);
    const loadingTimeout = new Promise((resolve) => {
      setTimeout(() => {
        setIsLoading(false);
        resolve();
      }, 2000);
    });
    try {
      const resp = await aboutUsData();
      if (resp.data.code === 200 || resp.data.code === 201) {
        setAboutUsAPIData(resp.data.responseBody);
      }
    } catch (error) {
      console.log("handlesubmit", error);
    } finally {
      await loadingTimeout;
    }
  };

  const renderContent = (htmlContent) => {
    // Sanitize the content manually without external libraries
    const sanitizedHtml = sanitizeHTML(htmlContent);
    return { __html: sanitizedHtml }; // Return HTML object for dangerouslySetInnerHTML
  };


  return (aboutUsAPIData && headerAPIData)?.length === 0 ? (
    <FullpageLoader />
  ) : (
    <>
      <div className="">
        <div className="about-us-container">
          <div className="molecule left">
            <img
              src={images.leftSpirrel}
              alt="Left Molecule"
              className="left-spinner"
            />
          </div>
          <div className="about-text">
            <h1>About Us</h1>
            <CommonBreadcrumbs items={breadcrumbsData} separator="›" />
          </div>
          <div className="molecule right">
            <img
              src={images.rightSpirrel}
              alt="Right Molecule"
              className="right-spinner"
            />
          </div>
        </div>
        <section className="about-us-who-section">
          <div className="common-sec">
            <Grid
              container
              spacing={{ xs: 3, md: 4, lg: 5 }}
              columnSpacing={{ xs: 0, md: 5, lg: 6 }}
              alignItems="flex-start"
            >
              <Grid item xs={12} lg={6}>
                <header className="about-us-who-header">
                  <span className="about-us-who-badge">Who We Are</span>
                  <h2 className="about-us-who-title">
                    {aboutUsAPIData[0]?.who_we_are?.title || "Anax Lifescience"}
                  </h2>
                </header>
                <div className="about-us-who-content">
                  {aboutUsAPIData[0]?.who_we_are?.points?.length > 0 ? (
                    <ul className="about-us-who-list">
                      {aboutUsAPIData[0].who_we_are.points.map((point, index) => (
                        <li key={index}>
                          <FaCircleCheck className="about-us-who-icon" aria-hidden />
                          <span>{point}</span>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="about-us-who-shimmer">
                      {[1, 2, 3, 4].map((i) => (
                        <div key={i} className="about-us-who-shimmer-line" />
                      ))}
                    </div>
                  )}
                </div>
              </Grid>

              <Grid item xs={12} sm={12} md={12} lg={6}>
                <div className="position">
                  {aboutUsAPIData[0]?.who_we_are?.about_image ? (
                    <div>
                      <img
                        src={aboutUsAPIData[0]?.who_we_are?.about_image}
                        alt="About Us"
                        className="about-image"
                      />
                    </div>
                  ) : (
                    <div
                      className="shimmer-image "
                      style={{ width: "70%", height: "500px" }}
                    ></div>
                  )}
                  <div className="inner-div">
                    {aboutUsAPIData[0]?.who_we_are?.about_image_title ? (
                      <>
                        <h2>
                          {aboutUsAPIData[0]?.who_we_are?.about_image_title}
                        </h2>
                        <p>
                          {
                            aboutUsAPIData[0]?.who_we_are
                              ?.about_image_description
                          }
                        </p>
                      </>
                    ) : (
                      <>
                        <div className="shimmer-text shimmer-title" aria-hidden="true" />
                        <p className="shimmer-text shimmer-description" aria-hidden="true" />
                      </>
                    )}
                  </div>
                </div>
              </Grid>
            </Grid>
          </div>
        </section>

        <div className=" pb-5">
          <AboutUsculture
            settingAPIDataChild={settingAPIData}
            headerAPIDataChild={headerAPIData}
            aboutUsAPIData={aboutUsAPIData}
          />
        </div>
        <div className="pt-4">
          <div className="vision-image-section">
            <div className="common-sec">
              <Grid container spacing={3} className="vision-cards-grid">
                {aboutUsAPIData[2]?.text_image?.map((item, index) => (
                  <Grid key={index} item xs={12} sm={6} md={6} lg={4}>
                    <div className="vision-mission-card">
                      <div className="shimmer-wrapper vision-card-image-wrap">
                        {isLoading ? (
                          <div className="shimmer-image-vision shimmer-vision"></div>
                        ) : (
                          <img
                            src={item?.image}
                            className="vision-card-image"
                            alt={item?.title || `Card ${index + 1}`}
                          />
                        )}
                      </div>
                      <div className="vision-card-body">
                        {isLoading ? (
                          <div className="vision-card-title">
                            <span className="shimmer-vision shimmer-title" aria-hidden="true" />
                          </div>
                        ) : (
                          <h2 className="vision-card-title">{item?.title}</h2>
                        )}
                        <p className="vision-card-text">
                          {isLoading ? (
                            <span className="shimmer-vision shimmer-description"></span>
                          ) : (
                            item?.description
                          )}
                        </p>
                      </div>
                    </div>
                  </Grid>
                ))}
              </Grid>

              <section className="journey-section">
                <header className="journey-header">
                  <span className="journey-badge">Our Story</span>
                  <h2 className="journey-title">Our Remarkable Journey & Achievement</h2>
                </header>
                <div className="journey-content">
                  {isLoading ? (
                    <div className="journey-shimmer">
                      <div className="shimmer-vision shimmer-description" style={{ marginBottom: 12 }} />
                      <div className="shimmer-vision shimmer-description" style={{ width: "90%", marginBottom: 12 }} />
                      <div className="shimmer-vision shimmer-description" style={{ width: "75%" }} />
                    </div>
                  ) : (
                    <div
                      className="journey-paragraph"
                      dangerouslySetInnerHTML={renderContent(aboutUsAPIData[2]?.description)}
                    />
                  )}
                </div>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Aboutus;
